import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import * as Constants from "../../../data/StringConstants";
import FoldersTable from "../../../components/Table/FoldersTable";
import { useContext } from "react";
import AppContext from "../../../data/AppContext";
import { FoldersApi } from '../../../api/folders/folders';

/**
 * This container is responsible for data fetching and rendering of corresponding sub-components
 * for the 'Atarred Folders' view which lists all promotions (folders) that have been starred by
 * the user. (Promotions created by that user are automatically starred).
 */
export default function StarredFoldersContainer(props) {
	const folderState = { data: [], totalItemCount: 0, isLoading: true };
	const [resp, setData] = useState(folderState);
	const appContext = useContext(AppContext);
	const queryParams = { starFilterType: "Starred", userId: appContext.user.UserID };
	const shownFolderCount = 100;
	useEffect(() => {
		let isCancelled = false;

		FoldersApi.fetchAllActiveStarredFoldersForAUser(queryParams)
			.then(resp => {
				const newState = {
					data: resp.data,
					totalItemCount: resp.data.length,
					isLoading: false
				};
				!isCancelled && setData(newState);
			})
			.catch(err => console.log(Constants.NO_FOLDERS_RESP_ERR, err));

		return () => (isCancelled = true);
	}, []);

	return resp.isLoading ? <LoadingSpinner /> :
		<FoldersTable
			data={resp.data}
			shownFolderCount={shownFolderCount}
			{...props}
		/>
}
